import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class CompanyToba extends RestApiModel {

  static getResourceEndpoint() {
    return '/companies/tobas';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }
}

export default CompanyToba;
